<template>
  <div>
    <div v-if="data" :id="id" :class="className" :style="{ height: height, width: width }" />
    <div v-else :class="className" :style="{ height: height, width: width, lineHeight:height }" style="text-align:center;color:#9e9e9e;font-size:0.8rem;">暂无数据</div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '170px'
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    data(v) {
      var that = this
      if (!v) {
        return
      }
      that.initChart();
    }
  },
  mounted() {
    var that = this
    if (that.data) {
      that.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function() {
      var that = this;
      var docChart = document.getElementById(that.id);

      // 配置图表主题
      var chart = echarts.init(docChart);

      var option = {
        // title: {
        //   top: 20,
        //   text: '请求总数量',
        //   textStyle: {
        //     fontWeight: 'normal',
        //     fontSize: 15
        //     // color: '#F1F1F3'
        //   },
        //   left: '1%'
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              // color: '#fff'
            }
          },
          formatter: function(params) {
            var fp = params[0]
            var ret = `<span style='font-size:12px;'>${fp.name}</span><br>${fp.marker}<span style='font-size:12px;'>${fp.seriesName}</span>
            <span style='font-weight:bold;color:#000;padding-left:15px;margin-right:5px;'>${fp.value}</span>M`
            return ret
          }
        },
        legend: {
          data: that.data.legend,
          top: 10,
          icon: 'roundRect',
          itemWidth: 20,
          itemHeight: 11,
          itemGap: 13,
          right: '7%',
          textStyle: {
            fontSize: 12
            // color: '#fff'
          }
        },
        grid: {
          top: '20%',
          left: '3%',
          right: '4.8%',
          bottom: '5%',
          containLabel: true
        },
        // 保存为图片
        // toolbox: {
        //   top: 4,
        //   right: '1.5%',
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          bottom: '5%',
          data: that.data.labels,
          axisLine: {
            lineStyle: {
              // color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              // color: '#fff'
            }
          },
          // max: 100,
          // min: 0,
          // 添加单位
          axisLabel: {
            formatter: '{value} M'
          }
        },
        series: [
          {
            data: that.data.values,
            name: '使用量',
            type: 'line',
            stack: '总量',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 0
              }
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00DDFF' },
                { offset: 1, color: '#4D77FF' }
              ])
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#00DDFF' },
                  { offset: 1, color: '#4D77FF' }
                ])
                // borderColor: 'rgba(3, 169, 244,0.2)',
                // borderWidth: 12
              }
            }
          }
        ]
      };

      chart.clear();
      chart.setOption(option);
    }
  }
};
</script>
